import ApartmentList from '../../features/admin/ApartmentList'

const ApartmentListPage = () => {
  
  return <ApartmentList />
}

export default ApartmentListPage